import React from 'react';
import { useHistory } from 'react-router-dom';

function Header({ title, onClose }) {
  const history = useHistory();

  const onClick = () => {
    if (onClose) {
      onClose();
    }
    else {
      history.goBack();
    }
  }

  return (
    <div className="header">
      <div className="inner">
        <div className="headerBox">
          <div className="headerBox_head">
            <h1 className="tit">{ title }</h1>
            <button
              className="btn-close-wrap"
              onClick={onClick}
            >닫기
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;